<template>
    <div id="pedido-resumo">
        <section id="content">
            <!--start container-->
            <div class="container">
                <!--card stats start-->
                <div id="card-stats">
                    <div class="row">
                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Processo de venda não iniciado'" :icone="'alarm'" :cor-fundo="'deep-orange'" :gradiente="'accent-2'" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="false" />
                        </div>

                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Contato telefônico'" :icone="'perm_phone_msg'" :cor-fundo="'lime'" :gradiente="'darken-4'" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="false" />
                        </div>

                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Visita'" :icone="'perm_contact_calendar'" :cor-fundo="'purple'" :gradiente="'accent-4'" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="false" />
                        </div>

                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Em negociação'" :icone="'attach_money'" :cor-fundo="'green'" :gradiente="''" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="false" />
                        </div>

                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Efetivado'" :icone="'check'" :cor-fundo="'green'" :gradiente="'darken-4'" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="true" />
                        </div>

                        <div class="col s6 m4 l2">
                            <card-info :titulo="'Não efetivado'" :icone="'close'" :cor-fundo="'red'" :gradiente="'darken-2'" :cor-texto="'white-text'" :mostrarPorcentagem="false" :marcadorAtual="false" />
                        </div>
                    </div>
                </div>
                <!--card stats end-->

                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <h4 class="header2">Resumo do pedido #{{pedido.id}}</h4>
                            <div class="row">
                                <div class="col s12 m12 l12">
                                    Produto: {{ pedido.produto }}
                                </div>
                            </div>

                            <ul id="profile-page-about-feed" class="collection z-depth-1">
                                <li class="collection-item avatar" v-for="estagio in reverseItems">
                                    <i :class="'material-icons circle '+estagio.color">{{estagio.icon}}</i>
                                    <span class="title">{{estagio.pessoa}}</span>
                                    <p>
                                        {{estagio.empresa}} - {{estagio.cargo}}
                                        <br>
                                        <span class="ultra-small">
                                            {{estagio.data}}
                                        </span>
                                    </p>
                                    <a href="#!" class="secondary-content">
                                        <i class="material-icons">check</i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<script>
    import CardInfo from '@/components/dashboard/CardInfo'

    export default {
        components: {
            CardInfo
        },
        data: () => ({
            pedido: {
                id: 1,
                produto: 'Seguro de vida',
                estagios: [
                    {
                        estagio: 'indicacao',
                        pessoa: 'João Paulo',
                        empresa: 'Empresa 1',
                        cargo: 'Gerente de parceria',
                        data: '01/01/2018'
                    },
                    {
                        estagio: 'contatoTelefonico',
                        pessoa: 'João Paulo Corretor',
                        empresa: 'Empresa Corretora',
                        cargo: 'Corretor',
                        data: '01/01/2018'
                    },
                    {
                        estagio: 'visita',
                        pessoa: 'João Paulo Corretor',
                        empresa: 'Empresa Corretora',
                        cargo: 'Corretor',
                        data: '01/01/2018'
                    },
                    {
                        estagio: 'negociacao',
                        pessoa: 'João Paulo Corretor',
                        empresa: 'Empresa Corretora',
                        cargo: 'Corretor',
                        data: '01/01/2018'
                    },
                    {
                        estagio: 'efetivado',
                        pessoa: 'João Paulo Corretor',
                        empresa: 'Empresa Corretora',
                        cargo: 'Corretor',
                        data: '01/01/2018'
                    }
                ]
            }
        }),
        created: function () {
            let ordens = [
                'indicacao',
                'contatoTelefonico',
                'visita',
                'negociacao',
                'efetivado',
                'negativado'
            ];

            let icons = [
                'alarm',
                'perm_phone_msg',
                'perm_contact_calendar',
                'attach_money',
                'check',
                'close'
            ];

            let colors = [
                'deep-orange accent-2',
                'lime darken-4',
                'purple accent-4',
                'green',
                'green darken-4',
                'red darken-2'
            ];

            this.pedido.estagios.forEach(function (value) {
                value.ordem = ordens.indexOf(value.estagio);
                value.icon = icons[value.ordem];
                value.color = colors[value.ordem];
            }, this);
        },
        methods: {
            save() {

            }
        },
        computed: {
            reverseItems() {
                return this.pedido.estagios.slice().reverse();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/pedidos/Resumo.vue